<div class="row">
  <inspectionFolder-edit
    [inspectionFolder]="folder"
    [processing]="processing"
    (toggleSaveInspectionFolder)="saveInspectionFolder($event)"
    (toggleCancel)="cancel()"
  ></inspectionFolder-edit>
</div>
